import {
  ChangeDetectionStrategy,
  Component,
  inject,
  signal,
} from '@angular/core';
import { PrimeIcons } from 'primeng/api';
import { Button } from 'primeng/button';
import { ReactiveFormsModule } from '@angular/forms';
import { UndoRedoService } from '../../../shared/services/design-tokens/undo-redo.service.ts';
import { Toast } from 'primeng/toast';
import { FormComponent, SubmitMethod } from '@tokenbox/utils';
import { Router } from '@angular/router';
import { Tooltip } from 'primeng/tooltip';

@Component({
  selector: 'dt-undo-redo-buttons',
  templateUrl: './undo-redo-buttons.component.html',
  styleUrls: ['./undo-redo-buttons.component.scss'],
  imports: [ReactiveFormsModule, Button, Toast, Tooltip],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class UndoRedoButtonsComponent implements FormComponent {
  protected readonly PrimeIcons = PrimeIcons;
  private undoRedoService = inject(UndoRedoService);
  private router = inject(Router);

  nextUndoableEvent = this.undoRedoService.nextUndoableEvent;
  nextRedoableEvent = this.undoRedoService.nextRedoableEvent;
  undoPossible = this.undoRedoService.undoIsPossible;
  redoPossible = this.undoRedoService.redoIsPossible;

  loading = signal<boolean>(false);
  responseError = signal<Error | null>(null);

  @SubmitMethod()
  async undo() {
    try {
      this.loading.set(true);
      const undoneEvent = await this.undoRedoService.undo();

      // if the user undoes a theme creation, trigger the route guards to make sure he doesn't stay on the now deleted theme's page:
      if (undoneEvent?.type === 'CREATE_THEMES') {
        void this.router.navigateByUrl(this.router.url, {
          onSameUrlNavigation: 'reload',
        });
      }

      // TODO[convenience-feature]: replace undo button with a SplitButton that opens a list of undoable events (like MS Word)
    } finally {
      this.loading.set(false);
    }
  }

  @SubmitMethod()
  async redo() {
    try {
      this.loading.set(true);
      await this.undoRedoService.redo();
    } finally {
      this.loading.set(false);
    }
  }
}
